import { render, staticRenderFns } from "./avatar.component.vue?vue&type=template&id=a9087a90"
import script from "./avatar.component.vue?vue&type=script&lang=js"
export * from "./avatar.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports